import React from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
// Styles
import styles from "./LocationSelector.css";

const LocationSelector = ({ onChangeLocation, locations, t, defaultLocation }) => (
  <form id="checkout-form" className="smart-form" style={styles.form}>
    <section style={styles.locationSection} className="col col-xs-12 col-sm-12 col-md-10 col-lg-7">
      <label htmlFor="location-menu" className="label">
        {t(`modules.localization.register.authenticated.exams.locations`)}
      </label>
      <div className="select">
        <select id="location-menu" value={defaultLocation} onChange={onChangeLocation}>
          <option value="">
            {t(`modules.localization.register.authenticated.exams.pickLocation`)}
          </option>
          {locations.map((location) => (
            <option value={location.id} key={location.id}>
              {location.name}
            </option>
          ))}
        </select>
        <i />
      </div>
    </section>
  </form>
);

LocationSelector.propTypes = {
  onChangeLocation: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  defaultLocation: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  t: PropTypes.func.isRequired
};

export default withNamespaces()(LocationSelector);
